import React, { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';
import { getSubsite } from '../../reducers/auth';
import { useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import axios from "../../reducers/authinterceptor";
import AuthHeader from "../../services/auth.header";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const AdminHome = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const currentSubsite = useSelector(getSubsite);
  const { isSuperAdmin } = useSelector(state => state.auth);
  const { hasCapabilities } = useSelector(state => state.auth);
  const { isAdmin } = useSelector(state => state.auth);

  useEffect(() => {
    // Don't load stats for super admins
    if(isAdmin) loadStats();
  }, [isAdmin]);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/stats",
        { headers: AuthHeader.authHeader() }
      );
      setStats(response.data);
    } catch (error) {
      console.error('Error loading admin stats:', error);
    } finally {
      setLoading(false);
    }
  };

  // Redirect super admins to super admin home
  if (isSuperAdmin) {
    return <Navigate to="/admin/super/home" replace />;
  }

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-4">
      {/* Subsite Logo */}

      {isAdmin && (
        <>
      <div style={{ backgroundColor: 'black', display: 'inline-block', padding: '10px', width:"100%", marginBottom: 20 }}>
        <img height="75" src={`${BACKEND_URL}/uploads/subsites/${currentSubsite.logoFilename}`} alt={currentSubsite.subsiteName} />
      </div>
      <h2 className="mb-4">{currentSubsite.subsiteName} Dashboard</h2>

      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Total Users</Card.Title>
              <h2 className="text-primary">{stats?.totalUsers || 0}</h2>
              <Link to="/admin/users" className="btn btn-sm btn-outline-primary mt-2">
                Manage Users
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Active Users</Card.Title>
              <h2 className="text-success">{stats?.activeUsers || 0}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Open Orders</Card.Title>
              <h2 className="text-warning">{stats?.openOrders || 0}</h2>
              <Link to="/admin/orders" className="btn btn-sm btn-outline-warning mt-2">
                View Orders
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {stats?.oldestOpenOrder && (
        <Row className="mb-4">
          <Col>
            <Card className="border-danger">
              <Card.Body>
                <Card.Title className="text-danger">⚠️ Oldest Open Order Alert</Card.Title>
                <p className="mb-0">
                  The oldest open order is <strong>{stats.oldestOpenOrder.daysOld} days old</strong>
                  {' '}(Order #{stats.oldestOpenOrder.orderId} from {new Date(stats.oldestOpenOrder.placed).toLocaleDateString()})
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <Row className="mb-4">
        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Recent Orders</h5>
            </Card.Header>
            <Card.Body>
              {stats?.recentOrders && stats.recentOrders.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Order #</th>
                        <th>Date</th>
                        <th>Ordered By</th>
                        <th className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stats.recentOrders.map((order, idx) => (
                        <tr key={idx}>
                          <td>{order.id}</td>
                          <td>{new Date(order.placed).toLocaleDateString()}</td>
                          <td>{order.orderedByName}</td>
                          <td className="text-end">${parseFloat(order.total).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">No recent orders</p>
              )}
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Quick Actions</h5>
            </Card.Header>
            <Card.Body>
              <div className="d-grid gap-2">
                <Link to="/admin/users" className="btn btn-outline-primary">
                  👥 Manage Users
                </Link>
                <Link to="/admin/orders" className="btn btn-outline-primary">
                  📦 View Orders
                </Link>
                <Link to="/admin/catalog" className="btn btn-outline-primary">
                  🛍️ Manage Catalog
                </Link>
                <Link to="/admin/reports" className="btn btn-outline-primary">
                  📊 View Reports
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      </>)}
    </Container>
  );
};
export default AdminHome;

